import {SetState} from "../../util/FormHandlers";
import React, {useMemo} from "react";
import {Autocomplete, TextField} from "@mui/material";
import {TextFieldProps} from "@mui/material/TextField/TextField";
import {useKeyDataStore} from "../../api/KeyDataStore";
import {useRemoteValue} from "../../util/RemoteValue";

export function CompanySelect({value, setValue, ...props}: {
    value: string | undefined,
    setValue: SetState<string | undefined>,
} & Omit<TextFieldProps, 'value' | 'onChange'>) {
    const keys = useKeyDataStore(state => state.remoteValue);

    const knownCompaniesRV = useMemo(() => {
        return keys.map(keys => {
            const companies = new Set<string>();
            keys.forEach(key => {
                key.history.forEach(record => {
                    if (record.location.type === 'with-guest' && !record.to && record.location.company) {
                        companies.add(record.location.company);
                    }
                });
            });
            return Array.from(companies).sort();
        });
    }, [keys]);

    const knownCompanies = useRemoteValue(knownCompaniesRV, []);

    return (
        <Autocomplete
            freeSolo
            options={knownCompanies}
            value={value || ""}
            onInputChange={(event, newValue) => {
                setValue(newValue || "");
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    {...props}
                />
            )}
        />
    );
}
